export default {
  countries: state => state.countries,
  countriesMap: state => state.countriesMap,
  countriesAsOf: state => state.countriesAsOf,
  regions: state => state.regions,
  regionsMap: state => state.regionsMap,
  regionsAsOf: state => state.regionsAsOf
};
